import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';
import styles from './Input.module.css';

export type InputSize = 'sm' | 'md' | 'lg';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  inputSize?: InputSize;
  invalid?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, inputSize = 'md', invalid, ...rest },
  ref
) {
  return (
    <input
      ref={ref}
      className={cn(styles.root, styles[`size_${inputSize}`], invalid && styles.root_invalid, className)}
      {...rest}
    />
  );
});
